import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderingDefinition } from '../../services/report.service';
import { FarmManagementService } from '../../services/farm-management.service';
import { Field } from '../../models/field';

export interface AnalysisOrderingDialogData {
  orderingDefinitions: OrderingDefinition[];
  selectedOrderingDefinitionId: number | null;
  showCombinedOption?: boolean;
  farmId?: number;
}

export interface AnalysisOrderingDialogResult {
  orderingDefinitionId: number | null;
  language: string;
  combined: boolean;
  orientation: string;
  labelSize: number | null;
  fieldIds: number[];
  labelColor: string | null;
  labelStrokeColor: string | null;
}

@Component({
  selector: 'app-analysis-ordering-definitions',
  templateUrl: './analysis-ordering-definitions.component.html',
  styleUrls: ['./analysis-ordering-definitions.component.css'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class AnalysisOrderingDefinitionsComponent implements OnInit {
  selectedId: number | null;
  language: string = 'en';
  combined: boolean = false;
  showCombinedOption: boolean = false;
  orientation: string = 'portrait';
  labelSize: number | null = null;
  selectedFieldIds: number[] = [];
  availableFields: Field[] = [];
  labelColor: string = '';
  labelStrokeColor: string = '';
  strokeEnabled: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AnalysisOrderingDialogData,
    private dialogRef: MatDialogRef<AnalysisOrderingDefinitionsComponent>,
    private farmManagementService: FarmManagementService
  ) {
    this.selectedId = data.selectedOrderingDefinitionId;
    this.showCombinedOption = data.showCombinedOption ?? false;
  }

  ngOnInit() {
    // Load persisted colours from sessionStorage
    this.labelColor = sessionStorage.getItem('reportLabelColor') || '#000000';
    this.labelStrokeColor = sessionStorage.getItem('reportLabelStrokeColor') || '#FFFFFF';
    this.strokeEnabled = sessionStorage.getItem('reportLabelStrokeColor') !== 'none';

    if (this.data.farmId) {
      this.farmManagementService.getFarmFields(this.data.farmId).subscribe(fields => {
        this.availableFields = fields || [];
      });
    }
  }

  removeField(fieldId: number) {
    this.selectedFieldIds = this.selectedFieldIds.filter(id => id !== fieldId);
  }

  getFieldName(fieldId: number): string {
    return this.availableFields.find(f => f.id === fieldId)?.name || '';
  }

  onConfirm() {
    const effectiveStrokeColor = this.strokeEnabled ? this.labelStrokeColor : 'none';
    
    // Persist colours to sessionStorage
    if (this.labelColor) sessionStorage.setItem('reportLabelColor', this.labelColor);
    if (effectiveStrokeColor) sessionStorage.setItem('reportLabelStrokeColor', effectiveStrokeColor);

    const result: AnalysisOrderingDialogResult = {
      orderingDefinitionId: this.selectedId,
      language: this.language,
      combined: this.combined,
      orientation: this.orientation,
      labelSize: this.labelSize,
      fieldIds: this.selectedFieldIds,
      labelColor: this.labelColor || null,
      labelStrokeColor: effectiveStrokeColor || null
    };
    this.dialogRef.close(result);
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
